<template>
  <div>
    <transition name="bottom_fade">
      <section
        v-show="!isScroll"
        class="search container fixed_bottom"
        :class="{ isTablet: isTablet }"
      >
        <div class="row">
          <div class="col-9 col-sm-8 col-md-5"></div>
          <div class="col-3 col-sm-4 col-md-7 text-right">
            <div class="col-12">
              <slot name="@function"></slot>
            </div>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  name: "fixedBotton",
  data() {
    return {
      touchEndPosition: 0,
      changePosition: 0,
      scrolltimeOutProcessId: "",
      isScroll: false, //是否滾動
    };
  },
  created() {
    if (!this.is_iPad) {
      window.addEventListener("scroll", this.scrollEvent);
    } else {
      window.addEventListener("scroll", this.ScrollEvent_iPad);
    }
  },
  computed: {
    is_iPad() {
      if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
      } else {
        // 部分 iPadPro 會顯示為 MacIntel
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }
    },
    isTablet() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      } else if (this.is_iPad) {
        return true;
      }
      return false;
    },
  },
  methods: {
    scrollEvent() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
    },

    ScrollEvent_iPad() {
      let clientHeight =
        document.documentElement.clientHeight ||
        document.scrollingElement.clientHeight;
      // 滾動上半部
      let scrollTop =
        document.documentElement.scrollTop ||
        document.scrollingElement.scrollTop;
      // 滾動總高度
      let scrollHeight =
        document.documentElement.scrollHeight ||
        document.scrollingElement.scrollHeight;

      if (scrollHeight - 100 < scrollTop + clientHeight) {
        this.isScroll = false;
      } else if (this.changePosition > scrollTop) {
        //向上
        this.isScroll = false;
      } else if (this.changePosition < scrollTop && scrollTop > 50) {
        //向下
        this.isScroll = true;
        this.touchEnd();
      }
      //此次事件位移點
      this.changePosition = scrollTop;
    },

    touchEnd() {
      // 滾動上半部
      let scrollTop =
        document.documentElement.scrollTop ||
        document.scrollingElement.scrollTop;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        if (this.touchEndPosition != scrollTop) {
          this.touchEndPosition = scrollTop;
          this.touchEnd();
        } else if (this.touchEndPosition == scrollTop) {
          this.isScroll = false;
        }
      }, 300);
    },
  },
  destroyed() {
    if (!this.is_iPad) {
      window.removeEventListener("scroll", this.scrollEvent);
    } else {
      window.removeEventListener("scroll", this.ScrollEvent_iPad);
    }
  },
};
</script>

<style  scoped>
.bottom_fade-enter-active,
.bottom_fade-leave-active {
  transition: all 0.1s ease;
}

.bottom_fade-enter,
.bottom_fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.fixed_bottom {
  z-index: 999;
  position: fixed;
  bottom: 0;
  right: 0;
  max-width: 100%;
  padding: 23px;
  background-color: #f5f5f5;
  box-shadow: rgb(158, 158, 158) 1px 3px 17px 0px;
}
.fixed_bottom.isTablet {
  padding: 8px;
  background: rgb(245, 245, 245, 0.65);
  box-shadow: rgb(158, 158, 158, 0.65) 1px 3px 17px 0px;
}
</style>
